module.exports = __webpack_public_path__ + "img/mobilepainpoint1.18e94808.png";